import { setCharCounter } from '~/actions/conversations';

import {
  createLinkTokenText,
  getEmbeddedWebLinks,
  getLinkTokens,
  removeEmbeddedWebLinks,
  removeLinkTokens,
} from '~/helpers';

export const processCharCounter = (text) => (dispatch, getState) => {
  if (!text) {
    dispatch(setCharCounter({ charCounter: 0 }));

    return;
  }

  const {
    mw_links: { links: mwLinks, linksLength },
    user: {
      config: { short_links_enabled },
    },
  } = getState();

  const tokens = getLinkTokens(text);

  if (tokens.length < 1 && !short_links_enabled) {
    dispatch(setCharCounter({ charCounter: text.length }));

    return;
  }

  if (!short_links_enabled) {
    let finalText = text;

    tokens.forEach((token) => {
      const link = mwLinks.find(({ id }) => id === Number(token));

      if (link !== undefined) {
        finalText = finalText.replace(createLinkTokenText(token), link.url);
      }
    });

    dispatch(
      setCharCounter({
        charCounter: finalText.length,
      })
    );

    return;
  }

  const plainLinks = getEmbeddedWebLinks(text);

  const tokenLinks = tokens.reduce((linksURLs, token) => {
    const link = mwLinks.find(({ id }) => id === Number(token));

    if (link?.url) {
      linksURLs.push(link.url);
    }

    return linksURLs;
  }, []);

  const allLinks = [...plainLinks, ...tokenLinks];

  if (allLinks.length < 1) {
    dispatch(
      setCharCounter({
        charCounter: text.length,
      })
    );

    return;
  }

  const charCounter =
    removeEmbeddedWebLinks(removeLinkTokens(text)).length +
    linksLength * allLinks.length;

  dispatch(
    setCharCounter({
      charCounter,
    })
  );
};
